<template>
  <div class="page_acSet">
    <div class="topOperation">
      <div class="top-left">
        <ShowNavHead />
      </div>
    </div>
    <div class="main-con">
      <div class="crumbs">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item>客户</el-breadcrumb-item>
          <el-breadcrumb-item>项目</el-breadcrumb-item>
          <el-breadcrumb-item :to="{ path: '/projectList' }">项目列表</el-breadcrumb-item>
          <el-breadcrumb-item>编辑项目</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="ftabs">
        <el-tabs v-model="activeName" @tab-click="changeTab" v-if="checkPermission(['projectList_edit'],permissionLists)">
          <el-tab-pane label="基本信息" name="0"></el-tab-pane>
          <el-tab-pane label="账套" name="1"></el-tab-pane>
        </el-tabs>
        <div style="height:20px" v-else></div>

        <div class="setItem">
          <div class="setTitle">
            预设开票内容
            <el-button type="text" @click="addInvoicing">+添加</el-button>
          </div>
          <el-table :data="InvoicingData" border class="doc_table" v-loading="loading" style="width:99%">
            <el-table-column prop="status" label="状态" min-width="80" :show-overflow-tooltip="true" align="center">
            </el-table-column>
            <el-table-column prop="subjectOfLegalAffairsId" label="开票主体" min-width="160" :show-overflow-tooltip="true" align="center">
            </el-table-column>
            <el-table-column prop="invoiceItem" label="发票项目" min-width="80" :show-overflow-tooltip="true" align="center">
            </el-table-column>
            <el-table-column prop="ticketTypeId" label="发票类型" min-width="80" :show-overflow-tooltip="true" align="center">
            </el-table-column>
            <el-table-column prop="billingItemDetailsId" label="开票内容" min-width="240" :show-overflow-tooltip="true" align="center">
            </el-table-column>
            <el-table-column prop="operatingData" label="最近启停操作" min-width="160" :show-overflow-tooltip="true" align="center">
            </el-table-column>
            <el-table-column label="操作" align="center" fixed="right" width="100px">
              <template slot-scope={row}>
                <div class="injuryTabBtn">
                  <el-button type="text" @click="invStopHandle(row,row.status=='启用' ? 1 : 0)">{{row.status == '启用' ? '停用' : '启用'}}</el-button>
                  <el-popconfirm title="请确定是否作废？" @confirm="invStopHandle(row,-1)" style="margin-left: 10px;">
                    <el-button type="text" slot="reference">作废</el-button>
                  </el-popconfirm>
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>

        <div class="setItem">
          <div class="setTitle">
            预设接收数电发票电子邮箱
            <el-button type="text" @click="addEmail">+添加</el-button>
          </div>
          <el-table :data="emailData" border class="doc_table" v-loading="loading" style="width:401px">
            <el-table-column prop="emailNo" label="客户接收发票电子邮箱" min-width="300" :show-overflow-tooltip="true" align="center">
            </el-table-column>
            <el-table-column label="操作" align="center" fixed="right" min-width="100px">
              <template slot-scope={row}>
                <div class="injuryTabBtn">
                  <el-popconfirm title="请确定是否作废？" @confirm="delEmail(row)" style="margin-left: 10px;">
                    <el-button type="text" slot="reference">作废</el-button>
                  </el-popconfirm>
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>

        <div class="setItem">
          <div class="setTitle">
            到款抬头
            <el-button type="text" @click="addRecBank">+添加</el-button>
          </div>
          <el-table :data="bankData" border class="doc_table" v-loading="loading" style="width:100%">
            <el-table-column prop="AccountName" label="开户名" min-width="180" :show-overflow-tooltip="true" align="center" fixed="left">
            </el-table-column>
            <el-table-column prop="Account" label="帐号" min-width="130" :show-overflow-tooltip="true" align="center">
            </el-table-column>
            <el-table-column prop="BankName" label="银行名称" min-width="100" :show-overflow-tooltip="true" align="center">
            </el-table-column>
            <el-table-column prop="OpeningBank" label="开户行" min-width="100" :show-overflow-tooltip="true" align="center">
            </el-table-column>
            <el-table-column prop="CreationMethod" label="创建方式" min-width="100" :show-overflow-tooltip="true" align="center">
            </el-table-column>
            <el-table-column prop="Creator" label="创建人" min-width="100" :show-overflow-tooltip="true" align="center">
            </el-table-column>
            <el-table-column prop="CreateTime" label="创建时间" min-width="150" :show-overflow-tooltip="true" align="center">
              <template slot-scope={row}>
                {{ row.CreateTime ? row.CreateTime.replace('T',' ') : ''}}
              </template>
            </el-table-column>
            <el-table-column prop="Remark" label="备注" min-width="100" :show-overflow-tooltip="true" align="center">
            </el-table-column>
            <el-table-column prop="StateStr" label="状态" min-width="100" :show-overflow-tooltip="true" align="center">
            </el-table-column>
            <el-table-column label="操作" align="center" fixed="right" min-width="140px">
              <template slot-scope={row}>
                <div class="injuryTabBtn">
                  <el-popconfirm :title="row.StateStr=='启用' ? '请确定是否停用？' : '请确定是否启用？'" @confirm="stopHandle(row,'1')" style="margin-right: 10px;">
                    <el-button type="text" slot="reference">{{row.StateStr=='启用' ? '停用' : '启用'}}</el-button>
                  </el-popconfirm>
                  <el-button type="text" @click="editBank(row)">修改</el-button>
                  <el-popconfirm title="请确定是否作废？" @confirm="delBnak(row)" style="margin-left: 10px;">
                    <el-button type="text" slot="reference">作废</el-button>
                  </el-popconfirm>
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>

        <div class="setItem">
          <div class="setTitle">
            开票抬头
            <el-button type="text" @click="addInvoice">+添加</el-button>
          </div>
          <el-table :data="invoiceData" border class="doc_table" v-loading="loading" style="width:100%">
            <el-table-column prop="AccountName" label="抬头名称" min-width="100" :show-overflow-tooltip="true" align="center" fixed="left">
            </el-table-column>
            <el-table-column prop="Account" label="纳税人识别号" min-width="120" :show-overflow-tooltip="true" align="center">
            </el-table-column>
            <el-table-column prop="PhoneNum" label="电话号码" min-width="110" :show-overflow-tooltip="true" align="center">
            </el-table-column>
            <el-table-column prop="OpeningBank" label="开户银行" min-width="100" :show-overflow-tooltip="true" align="center">
            </el-table-column>
            <el-table-column prop="BankAccount" label="银行账号" min-width="100" :show-overflow-tooltip="true" align="center">
            </el-table-column>
            <el-table-column prop="BusinessAddress" label="营业地址" min-width="100" :show-overflow-tooltip="true" align="center">
            </el-table-column>
            <el-table-column prop="CreationMethod" label="创建方式" min-width="100" :show-overflow-tooltip="true" align="center">
            </el-table-column>
            <el-table-column prop="CreateTime" label="创建时间" min-width="150" :show-overflow-tooltip="true" align="center">
              <template slot-scope={row}>
                {{ row.CreateTime ? row.CreateTime.replace('T',' ') : ''}}
              </template>
            </el-table-column>
            <el-table-column prop="Remark" label="备注" min-width="100" :show-overflow-tooltip="true" align="center">
            </el-table-column>
            <el-table-column prop="StateStr" label="状态" min-width="100" :show-overflow-tooltip="true" align="center">
            </el-table-column>
            <el-table-column label="操作" align="center" fixed="right" min-width="140px">
              <template slot-scope={row}>
                <div class="injuryTabBtn">
                  <el-popconfirm :title="row.StateStr=='启用' ? '请确定是否停用？' : '请确定是否启用？'" @confirm="stopHandle(row,'2')" style="margin-right: 10px;">
                    <el-button type="text" slot="reference">{{row.StateStr=='启用' ? '停用' : '启用'}}</el-button>
                  </el-popconfirm>
                  <el-button type="text" @click="editInvoice(row)">修改</el-button>
                  <el-popconfirm title="请确定是否作废？" @confirm="delInvoice(row)" style="margin-left: 10px;">
                    <el-button type="text" slot="reference">作废</el-button>
                  </el-popconfirm>
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>

        <div class="setItem">
          <div class="setTitle">
            预设结算单收发邮箱、邮件标题关键词
          </div>
          <div class="setTitle">
            <el-button type="text" @click="addSendEmail">+添加客户发送结算单邮箱</el-button>
          </div>
          <el-table :data="aiSetform.senReceivedEmail" border class="doc_table" v-loading="loading" style="width:601px">
            <el-table-column prop="EmailAddress" label="客户发送结算单邮箱" min-width="300" :show-overflow-tooltip="true" align="center">
            </el-table-column>
            <el-table-column prop="StartTime" label="发送开始时间" min-width="100" :show-overflow-tooltip="true" align="center">
            </el-table-column>
            <el-table-column prop="endTime" label="发送结束时间" min-width="100" :show-overflow-tooltip="true" align="center">
            </el-table-column>
            <el-table-column label="操作" align="center" min-width="100px">
              <template slot-scope={$index}>
                <div class="injuryTabBtn">
                  <el-popconfirm title="请确定是否作废？" @confirm="delSendEmail('senReceivedEmail',$index)" style="margin-left: 10px;">
                    <el-button type="text" slot="reference">作废</el-button>
                  </el-popconfirm>
                </div>
              </template>
            </el-table-column>
          </el-table>

          <div class="setTitle" style="margin-top: 20px">
            <el-button type="text" @click="addReceivedEmail">+添加我方接收结算单邮箱</el-button>
          </div>
          <el-table :data="aiSetform.statementSenReceivedEmail" border class="doc_table" v-loading="loading" style="width:601px;margin-bottom: 10px;">
            <el-table-column prop="EmailAddress" label="我方接收结算单邮箱" min-width="300" :show-overflow-tooltip="true" align="center">
            </el-table-column>
            <el-table-column prop="pwd" label="密码" min-width="200" :show-overflow-tooltip="true" align="center">
              <template slot-scope="{row}">
                <span>******</span>
                <span class="blueName cp" style="margin-left: 10px;" @click="showPassword(row)">显示</span>
              </template>
            </el-table-column>
            <el-table-column label="操作" align="center" min-width="100px">
              <template slot-scope={$index}>
                <div class="injuryTabBtn">
                  <el-popconfirm title="请确定是否作废？" @confirm="delSendEmail('statementSenReceivedEmail',$index)" style="margin-left: 10px;">
                    <el-button type="text" slot="reference">作废</el-button>
                  </el-popconfirm>
                </div>
              </template>
            </el-table-column>
          </el-table>

          <el-form label-width="200px" class="settlement_form">
            <el-form-item label="邮件标题关键词">
              <el-input v-model="aiSetform.mailSubjectKeyword" style="width:300px" size="small"></el-input>
              <div class="tips" style="margin-bottom: -10px;">注：多个关键词请用逗号，分隔开</div>
            </el-form-item>

            <el-form-item label="结算单自动提交发薪是否算税">
              <el-select v-model="aiSetform.inComeTpye" placeholder="" style="width: 300px;" size="small" clearable filterable>
                <el-option value="正常工资薪金"></el-option>
                <el-option value="劳务报酬"></el-option>
                <el-option value="全年一次性奖金（一次扣税）"></el-option>
                <el-option value="全年多次性奖金（多次发放）"></el-option>
                <el-option value="解除劳动合同一次性补偿"></el-option>
                <el-option value="不算税"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="个税申报月加">
              <el-select v-model="aiSetform.IncomeTaxMonth" placeholder="" style="width: 300px;" size="small" clearable filterable>
                <el-option :value="0"></el-option>
                <el-option :value="1"></el-option>
                <el-option :value="2"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="归属月">
              <el-select v-model="aiSetform.AttrMonth" placeholder="" style="width: 300px;" size="small" clearable filterable>
                <el-option :value="-5"></el-option>
                <el-option :value="-4"></el-option>
                <el-option :value="-3"></el-option>
                <el-option :value="-2"></el-option>
                <el-option :value="-1"></el-option>
                <el-option :value="0"></el-option>
                <el-option :value="1"></el-option>
                <el-option :value="2"></el-option>
                <el-option :value="3"></el-option>
                <el-option :value="4"></el-option>
                <el-option :value="5"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="第几个sheet">
              <el-select v-model="aiSetform.ExcelSheetNum" placeholder="" style="width: 300px;" size="small" clearable filterable>
                <el-option v-for="(item,index) in 10" :key="index" :value="item"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="Excel密码">
              <el-input v-model="aiSetform.ExcelPwd" style="width:300px" size="small"></el-input>
            </el-form-item>
            <el-form-item label="税前工资单">
              <el-checkbox style="margin-left: 20px;" v-model="aiSetform.isAutoPreTaxPayroll" @change="changePreTax">自动生成</el-checkbox>
              <el-checkbox style="margin-left: 20px;" v-model="aiSetform.isAutoPreTaxToCustomer" v-if="aiSetform.isAutoPreTaxPayroll">自动回传客户</el-checkbox>
            </el-form-item>
            <el-form-item label="税后工资单">
              <el-checkbox style="margin-left: 20px;" v-model="aiSetform.isAutoAfterTaxPayroll" @change="changeAfterTax">自动生成</el-checkbox>
              <el-checkbox style="margin-left: 20px;" v-model="aiSetform.isAutoAfterTaxToCustomer" v-if="aiSetform.isAutoAfterTaxPayroll">自动回传客户</el-checkbox>
            </el-form-item>

            <el-form-item label="对账单">
              <el-checkbox style="margin-left: 20px;" v-model="aiSetform.isAutoStateAccount" @change="changeStateAccount">自动生成</el-checkbox>
              <el-checkbox style="margin-left: 20px;" v-model="aiSetform.isAutoStateAccountToCustomer" v-if="aiSetform.isAutoStateAccount">自动回传客户</el-checkbox>
            </el-form-item>
            <el-form-item label="算税失败通知项目客服">
              <el-radio-group v-model="aiSetform.taxErrNotiy">
                <el-radio label="1">是</el-radio>
                <el-radio label="0">否</el-radio>
              </el-radio-group>
            </el-form-item>

            <div class="setTitle">
              日薪社灵活用工发薪设置
            </div>
            <el-form-item label="个税申报月">
              <el-select v-model="aiSetform.SpIncomeTaxType" placeholder="" style="width: 180px;" size="small" clearable filterable>
                <el-option v-for="item in 11" :key="item-6" :value="item-6" :label="(item-6)>=0 ? '+' + (item-6) : (item-6)"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="归属月">
              <el-select v-model="aiSetform.SpAttrMonth" placeholder="" style="width: 180px;" size="small" clearable filterable>
                <el-option v-for="item in 11" :key="item-6" :value="item-6" :label="(item-6)>=0 ? '+' + (item-6) : (item-6)"></el-option>
              </el-select>
            </el-form-item>
          </el-form>
        </div>


        <div class="setItem">
          <div class="setTitle">
            发薪主体
            <el-button type="text" @click="addLeg">+添加</el-button>
          </div>
          <el-table :data="legData" border class="doc_table" v-loading="loading" style="width:100%">
            <el-table-column prop="AccountName" label="主体名称" min-width="100" :show-overflow-tooltip="true" align="center" fixed="left">
            </el-table-column>
            <el-table-column prop="BankAccount" label="帐号" min-width="100" :show-overflow-tooltip="true" align="center">
            </el-table-column>
            <el-table-column prop="BankName" label="银行名称" min-width="100" :show-overflow-tooltip="true" align="center">
            </el-table-column>
            <el-table-column prop="OpeningBank" label="开户行" min-width="100" :show-overflow-tooltip="true" align="center">
            </el-table-column>
            <el-table-column prop="CreationMethod" label="创建方式" min-width="100" :show-overflow-tooltip="true" align="center">
            </el-table-column>
            <el-table-column prop="Creator" label="创建人" min-width="100" :show-overflow-tooltip="true" align="center">
            </el-table-column>
            <el-table-column prop="CreateTime" label="创建时间" min-width="150" :show-overflow-tooltip="true" align="center">
              <template slot-scope={row}>
                {{ row.CreateTime ? row.CreateTime.replace('T',' ') : ''}}
              </template>
            </el-table-column>
            <el-table-column prop="Remark" label="备注" min-width="100" :show-overflow-tooltip="true" align="center">
            </el-table-column>
            <el-table-column prop="StateStr" label="状态" min-width="100" :show-overflow-tooltip="true" align="center">
            </el-table-column>
            <el-table-column label="操作" align="center" fixed="right" min-width="140px">
              <template slot-scope={row}>
                <div class="injuryTabBtn">
                  <el-popconfirm :title="row.StateStr=='启用' ? '请确定是否停用？' : '请确定是否启用？'" @confirm="stopHandle(row,'3')" style="margin-right: 10px;">
                    <el-button type="text" slot="reference">{{row.StateStr=='启用' ? '停用' : '启用'}}</el-button>
                  </el-popconfirm>
                  <el-button type="text" @click="editLeg(row)">修改</el-button>
                  <el-popconfirm title="请确定是否作废？" @confirm="delLeg(row)" style="margin-left: 10px;">
                    <el-button type="text" slot="reference">作废</el-button>
                  </el-popconfirm>
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>


        <div class="setItem">
          <div class="setTitle">
            项目文档
            <el-button type="text" @click="AddProjectDoc">+添加</el-button>
          </div>
          <el-table :data="docData" border class="doc_table" v-loading="loading" style="width:100%">
            <el-table-column prop="title" label="文档标题" min-width="150" :show-overflow-tooltip="true" align="center" fixed="left">
            </el-table-column>
            <el-table-column prop="purpose" label="用途" min-width="100" :show-overflow-tooltip="true" align="center">
            </el-table-column>
            <el-table-column prop="sign" label="标志" min-width="100" :show-overflow-tooltip="true" align="center">
            </el-table-column>
            <el-table-column prop="url" label="文件" min-width="100" :show-overflow-tooltip="true" align="center">
              <template slot-scope="{row}">
                <div class="blueName cp" @click="downFile(row)">下载</div>
              </template>
            </el-table-column>
            <el-table-column prop="status" label="状态" min-width="100" :show-overflow-tooltip="true" align="center">
            </el-table-column>
            <el-table-column prop="modification" label="最近启停操作" min-width="200" :show-overflow-tooltip="true" align="center">
            </el-table-column>
            <el-table-column label="操作" align="center" fixed="right" min-width="140px">
              <template slot-scope={row}>
                <div class="injuryTabBtn">
                  <el-popconfirm :title="row.status=='启用中' ? '请确定是否停用？' : '请确定是否启用？'" @confirm="stopDoc(row,row.status=='启用中' ? 1 : 0)" style="margin-right: 10px;">
                    <el-button type="text" slot="reference">{{row.status=='启用中' ? '停用' : '启用'}}</el-button>
                  </el-popconfirm>
                  <el-popconfirm title="请确定是否作废？" @confirm="stopDoc(row,2)" style="margin-left: 10px;">
                    <el-button type="text" slot="reference">作废</el-button>
                  </el-popconfirm>
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>

        <div class="setItem">
          <div class="setTitle">
            薪酬相关
          </div>
          <el-form :model="payForm" ref="payForm" :rules="rules" label-width="170px">
            <el-form-item label="小数点保留位数" prop="DecimalPointNum">
              <el-select v-model="payForm.DecimalPointNum" placeholder="" style="width: 200px;" size="small" clearable filterable>
                <el-option v-for="(item,index) in pointNum" :key="index" :value="item"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="小数末位处理" prop="DecimalEndProcessing">
              <el-radio-group v-model="payForm.DecimalEndProcessing">
                <el-radio label="四舍五入">四舍五入</el-radio>
                <el-radio label="五舍六入">五舍六入</el-radio>
                <el-radio label="向上取整">向上取整</el-radio>
                <el-radio label="向下取整">向下取整</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="个税承担方式">
              <el-radio-group v-model="aiSetform.PersonalTaxIsBorne">
                <el-radio :label="false">企业承担</el-radio>
                <el-radio :label="true">个人承担</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="缺省签约/发薪主体" prop="DefaultContracting">
              <el-select v-model="payForm.DefaultContracting" placeholder="" size="small" style="width: 200px;" clearable filterable>
                <el-option v-for="(item,index) in legList" :key="index" :value="item.CompanyName"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="发薪日期" prop="PayDay">
              <el-select v-model="payForm.PayDay" placeholder="" size="small" style="width: 200px;" filterable>
                <el-option v-for="(item,index) in 31" :key="index" :value="item + '日'"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="银行代发类型" prop="PayDay">
              <el-select v-model="payForm.BankExtend8" placeholder="" size="small" style="width: 200px;" filterable clearable>
                <el-option v-for="(item,index) in DFtype" :key="index" :value="item"></el-option>
              </el-select>
            </el-form-item>

            <el-form-item>
              <el-button type="primary" @click="saveAccountSet">保存</el-button>
            </el-form-item>
          </el-form>
        </div>

      </div>
    </div>

    <el-dialog title="添加到款银行" :visible.sync="showRecBank" width="900px">
      <el-form :model="bankForm" :inline="true" ref="bankForm" :rules="bankRules" label-width="100px">
        <el-form-item label="户名" prop="AccountName">
          <el-input v-model="bankForm.AccountName" style="width:300px" size="small"></el-input>
        </el-form-item>
        <el-form-item label="账号" prop="Account">
          <el-input v-model="bankForm.Account" style="width:300px" size="small"></el-input>
        </el-form-item>
        <el-form-item label="银行名称" prop="BankName">
          <el-input v-model="bankForm.BankName" style="width:300px" size="small"></el-input>
        </el-form-item>
        <el-form-item label="开户行" prop="OpeningBank">
          <el-input v-model="bankForm.OpeningBank" style="width:300px" size="small"></el-input>
        </el-form-item>
        <el-form-item label="备注" prop="Remark">
          <el-input v-model="bankForm.Remark" style="width:300px" size="small"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showRecBank = false" size="small">取 消</el-button>
        <el-button type="primary" v-preventReClick style="margin-left:10px;" size="small" @click="confirmAddBank">提 交</el-button>
      </span>
    </el-dialog>

    <el-dialog title="添加发票抬头" :visible.sync="showInvoice" width="900px">
      <div class="tips">注：开具专票地址、电话、开户行及账号必填</div>
      <el-form :model="invoiceForm" :inline="true" ref="invoiceForm" :rules="titleRules" label-width="110px">
        <el-form-item label="抬头名称" prop="AccountName">
          <el-input v-model.trim="invoiceForm.AccountName" @input="invoiceForm.AccountName = filterInput(invoiceForm.AccountName)" style="width:300px" size="small"></el-input>
        </el-form-item>
        <el-form-item label="纳税人识别号" prop="Account">
          <el-input v-model="invoiceForm.Account" style="width:300px" size="small"></el-input>
        </el-form-item>
        <el-form-item label="电话号码">
          <el-input v-model="invoiceForm.PhoneNum" style="width:300px" size="small"></el-input>
        </el-form-item>
        <el-form-item label="营业地址">
          <el-input v-model="invoiceForm.BusinessAddress" style="width:300px" size="small"></el-input>
        </el-form-item>
        <el-form-item label="银行账号">
          <el-input v-model="invoiceForm.BankAccount" style="width:300px" size="small"></el-input>
        </el-form-item>
        <el-form-item label="开户银行">
          <el-input v-model="invoiceForm.OpeningBank" style="width:300px" size="small"></el-input>
        </el-form-item>
        <el-form-item label="备注">
          <el-input v-model="invoiceForm.Remark" style="width:300px" size="small"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showInvoice = false" size="small">取 消</el-button>
        <el-button type="primary" v-preventReClick style="margin-left:10px;" size="small" @click="confirmAddInvoice">提 交</el-button>
      </span>
    </el-dialog>

    <el-dialog title="添加发薪主体" :visible.sync="showLeg" width="900px">
      <el-form :model="legForm" :inline="true" ref="legForm" :rules="rules" label-width="100px">
        <el-form-item label="主体名称" prop="AccountName">
          <el-select v-model="legForm.AccountName" placeholder="" size="small" style="width: 300px;" clearable filterable>
            <el-option v-for="(item,index) in legList" :key="index" :value="item.CompanyName"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="帐号" prop="BankAccount">
          <el-input v-model="legForm.BankAccount" style="width:300px" size="small"></el-input>
        </el-form-item>
        <el-form-item label="银行名称" prop="BankName">
          <el-input v-model="legForm.BankName" style="width:300px" size="small"></el-input>
        </el-form-item>
        <el-form-item label="开户行" prop="OpeningBank">
          <el-input v-model="legForm.OpeningBank" style="width:300px" size="small"></el-input>
        </el-form-item>
        <el-form-item label="备注" prop="Remark">
          <el-input v-model="legForm.Remark" style="width:300px" size="small"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showLeg = false" size="small">取 消</el-button>
        <el-button type="primary" v-preventReClick style="margin-left:10px;" size="small" @click="confirmAddLeg">提 交</el-button>
      </span>
    </el-dialog>

    <el-dialog title="新增项目文档" :visible.sync="showAddProjectDoc" width="550px">
      <el-form :model="proDocForm" ref="proDocForm" :rules="rules" label-width="110px">
        <el-form-item label="用途" prop="purpose">
          <el-select v-model="proDocForm.purpose" placeholder="" size="small" style="width: 300px;" clearable filterable>
            <el-option label="面试" :value="1"></el-option>
            <el-option label="入职" :value="2"></el-option>
            <el-option label="在职" :value="3"></el-option>
            <el-option label="离职" :value="4"></el-option>
            <el-option label="知识库" :value="5"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="标志" prop="sign">
          <el-select v-model="proDocForm.sign" placeholder="" size="small" style="width: 300px;" clearable filterable>
            <el-option label="面试注意事项" :value="1"></el-option>
            <el-option label="入职须知" :value="2"></el-option>
            <el-option label="体检须知" :value="3"></el-option>
            <el-option label="宿舍管理须知" :value="4"></el-option>
            <el-option label="离职流程" :value="5"></el-option>
            <el-option label="安全相关" :value="6"></el-option>
            <el-option label="员工手册" :value="7"></el-option>
            <el-option label="保险政策咨询" :value="8"></el-option>
            <el-option label="个人收入证明申请" :value="9"></el-option>
            <el-option label="其他" :value="0"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="文档显示标题" prop="title">
          <el-input v-model="proDocForm.title" style="width:300px" size="small"></el-input>
        </el-form-item>
        <el-form-item label="上传文件" prop="url">
          <el-upload class="upload-demo" action="" :on-remove="handleRemove" multiple :limit="1" :auto-upload="false" :on-exceed="handleExceed" :on-change="handleUpload" :file-list="fileList">
            <el-button size="small" type="primary">点击上传</el-button>
          </el-upload>
        </el-form-item>
        <el-form-item label="备注">
          <el-input v-model="proDocForm.remark" style="width:300px" size="small"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showAddProjectDoc = false" size="small">取 消</el-button>
        <el-button type="primary" v-preventReClick style="margin-left:10px;" size="small" @click="confirmAddDoc">提 交</el-button>
      </span>
    </el-dialog>

    <el-dialog title="预设接收数电发票电子邮箱" :visible.sync="showEmail" width="500px">
      <el-form :model="emailForm" :inline="true" ref="bankForm" :rules="emailRulse" label-width="100px">
        <el-form-item label="电子邮箱" prop="emailNo">
          <el-input v-model="emailForm.emailNo" style="width:300px" size="small"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showEmail = false" size="small">取 消</el-button>
        <el-button type="primary" v-preventReClick style="margin-left:10px;" size="small" @click="confirmAddEmail" :loading="isBtnLoading">提 交</el-button>
      </span>
    </el-dialog>

    <el-dialog title="添加预设开票内容" :visible.sync="showInvoicing" width="500px">
      <el-form :model="invPresetsForm" ref="invPresetsForm" :rules="rules" label-width="100px">
        <el-form-item label="开票主体" prop="subjectOfLegalAffairsId">
          <el-select v-model="invPresetsForm.subjectOfLegalAffairsId" placeholder="" size="small" style="width: 300px;" clearable filterable>
            <el-option v-for="(item,index) in legList2" :key="index" :label="item.value" :value="item.key"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="发票项目" prop="invoiceItem">
          <el-select v-model="invPresetsForm.invoiceItem" placeholder="" size="small" @change="changeInvoiceItem" style="width: 300px;">
            <el-option label="服务费" :value="1"></el-option>
            <el-option label="劳务费" :value="2"></el-option>
            <el-option label="管理费" :value="3"></el-option>
            <el-option label="工资" :value="-1"></el-option>
            <el-option label="社保" :value="-2"></el-option>
            <el-option label="公积金" :value="-3"></el-option>
            <el-option label="个税" :value="-4"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="发票类型" prop="ticketTypeId">
          <el-select v-model="invPresetsForm.ticketTypeId" placeholder="" size="small" @change="changeTicketType" style="width: 300px;">
            <el-option v-for="item in ticketTypeList" :key="item.key" :label="item.value" :value="item.key"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="开票内容" prop="billingItemDetailsId">
          <el-select v-model="invPresetsForm.billingItemDetailsId" placeholder="" size="small" style="min-width: 300px;" filterable>
            <el-option v-for="item in BillingConList" :key="item.key" :label="item.value" :value="item.key"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showInvoicing = false" size="small">取 消</el-button>
        <el-button type="primary" v-preventReClick style="margin-left:10px;" size="small" @click="confirmAddInvoicing">提 交</el-button>
      </span>
    </el-dialog>


    <el-dialog title="添加客户发送结算单邮箱" :visible.sync="showSendEmail" width="500px">
      <el-form :model="sendForm" :rules="emailRulse" ref="sendForm" label-width="110px">
        <el-form-item label="邮箱" prop="EmailAddress">
          <el-input v-model="sendForm.EmailAddress" style="width:300px" size="small"></el-input>
        </el-form-item>
        <el-form-item label="发送开始时间" prop="StartTime">
          <el-select v-model="sendForm.StartTime" placeholder="" size="small" style="width: 300px;">
            <el-option v-for="(item,index) in 31" :key="index" :label="item + '号'" :value="item"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="发送结束时间" prop="endTime">
          <el-select v-model="sendForm.endTime" placeholder="" size="small" style="width: 300px;">
            <el-option v-for="(item,index) in 31" :key="index" :label="item + '号'" :value="item"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showSendEmail = false" size="small">取 消</el-button>
        <el-button type="primary" v-preventReClick style="margin-left:10px;" size="small" @click="confirmAddSendEmail">确 认</el-button>
      </span>
    </el-dialog>

    <el-dialog title="添加我方接收结算单邮箱" :visible.sync="showReceivedEmail" width="500px">
      <el-form :model="ReceivedForm" ref="ReceivedForm" label-width="100px">
        <el-form-item label="邮箱">
          <el-input v-model="ReceivedForm.EmailAddress" style="width:300px" size="small"></el-input>
        </el-form-item>
        <el-form-item label="密码">
          <el-input v-model="ReceivedForm.pwd" style="width:300px" size="small"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showReceivedEmail = false" size="small">取 消</el-button>
        <el-button type="primary" v-preventReClick style="margin-left:10px;" size="small" @click="confirmReceivedEmail">确 认</el-button>
      </span>
    </el-dialog>

    <el-dialog title="显示密码" :visible.sync="showPwd" width="500px" :show-close="false">
      <el-form>
        <el-form-item label="请输入验证码" label-width="100px">
          <el-input v-model="VerifCode" style="width:120px" size="small"></el-input>
          <el-button type="primary" size="small" style="margin-left:10px" :disabled="countdown>0" @click="sendSms" :loading="isBtnLoading">{{countdown == 0 ? '发送短信' : '重新发送（' + countdown + '）'}}</el-button>
        </el-form-item>
      </el-form>
      <div>注:验证码将发放到您在数字化系统登记的手机号</div>
      <div style="margin-top: 10px;" v-if="psw">您的密码是：
        <span style="font-weight: bold;">{{ psw }}</span>
        <span @click="repeatHandle">
          <i class="el-icon-document-copy r_icon01 cp"></i>
        </span>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showPwd = false" size="small">取 消</el-button>
        <el-button type="primary" v-preventReClick style="margin-left:10px;" size="small" @click="checkSms">确认</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  import {
    index
  } from "mathjs";
  import xz from "../../common";
  import checkPermission from '@/utils/permission' // 权限判断函数
  import {
    del
  } from "vue";
  import AddProject from "./addProject.vue";
  export default {
    data() {
      return {
        listQuery: {
          name: '',
          pageNum: 1,
          pageSize: 10,
        },
        showDropScreen: -1,
        payForm: {
          Id: '',
          ProjectId: this.projectid,
          DecimalPointNum: '', //小数点保留位数
          DecimalEndProcessing: '', //小数末位处理
          DefaultContracting: '', //缺省签约/发薪主体
          PayDay: '', //	发薪日
          BankExtend8: '', //银行代发类型
        },
        bankData: [],
        bankForm: {
          Id: '',
          ProjectId: this.projectid,
          AccountName: '', //开户名
          Account: '', //帐号
          BankName: '', //银行名称
          OpeningBank: '', //开户行
          Remark: '', //	备注
          stateStr: '启用', //状态
        },
        invoiceData: [],
        invoiceForm: {
          Id: '',
          ProjectId: this.projectid,
          AccountName: '', //抬头名称
          Account: '', //纳税人识别号
          PhoneNum: '', //电话号码
          OpeningBank: '', //开户行
          BankAccount: '', //银行账号
          BusinessAddress: '', //营业地址
          Remark: '', //	备注
          stateStr: '启用', //状态
        },
        titleRules: {
          AccountName: [{
              required: true,
              message: '请输入抬头名称',
              trigger: 'blur'
            },
            {
              validator: (rule, value, callback) => {
                if (value.includes(' ')) {
                  callback(new Error('抬头名称不能包含空格'));
                } else {
                  callback();
                }
              },
              trigger: 'blur'
            }
          ],
          Account: {
            required: true,
            message: '请输入纳税人识别号',
            trigger: 'blur'
          },
          PhoneNum: {
            required: true,
            message: '请输入电话号码',
            trigger: 'blur'
          },
          BusinessAddress: {
            required: true,
            message: '请输入营业地址',
            trigger: 'blur'
          },
          BankAccount: {
            required: true,
            message: '请输入银行账号',
            trigger: 'blur'
          },
          OpeningBank: {
            required: true,
            message: '请输入开户银行',
            trigger: 'blur'
          },
        },
        legData: [],
        legForm: {
          Id: '',
          ProjectId: this.projectid,
          AccountName: '', //主体名称
          BankAccount: '', //银行账号
          OpeningBank: '', //开户行
          BankName: '', //银行名称
          Remark: '', //	备注
          stateStr: '启用', //状态
        },
        pointNum: [0, 1, 2, 3, 4],
        roletype: localStorage.loginRoletype,
        totalCount: 0,
        projectid: '',
        activeName: '1',
        loading: false,
        legList: [], //主体列表
        showRecBank: false, //添加到款银行弹窗
        showInvoice: false, //添加发票抬头
        showLeg: false, //添加主体
        permissionLists: [],
        // 按钮权限参数
        DFtype: ['代发加班费', '代发劳务收入', '代发奖金', '代发投资本益', '代发报销款', '代发福利费', '代发纳税退还', '代发继承赠与款', '代发网上交易费', '代发补贴费', '代发证券期货款', '代发信托返还资金', '代发递延奖金', '代发通讯费', '代发交通费', '代发差旅费', '代发分红款', '代发住房公积金', '代发改制费', '离岸代发工资', '代发烤火费', '代发车贴', '综合代发款', '代发其他', '代发佣金-BYXT'],
        butQuery: {
          path: '/projectList',
          powerEnName: 'projectManage'
        },
        stopForm: {
          type: '', // 1到款银行 2 开票抬头 3发薪主体
          StateStr: '', //状态
          id: '',
        },
        emailForm: {
          projectEmailId: '',
          projectId: '',
          emailNo: '',
        },
        isBtnLoading: false,
        emailData: [],
        showEmail: false,
        showInvoicing: false,
        InvoicingData: [], //预设开票内容
        invPresetsForm: {
          invoiceContentId: "",
          projectId: 0,
          subjectOfLegalAffairsId: "", //主体id
          invoiceItem: '', //发票项目
          ticketTypeId: "", //票种id
          billingItemDetailsId: "", //开票内容id
          founder: Cookies.get("userid-b")
        },
        ticketTypeList: [],
        BillingConList: [],
        legList2: [],
        bankRules: {
          AccountName: {
            required: true,
            message: '请输入户名',
            trigger: 'blur'
          },
          Account: {
            required: true,
            message: '请输入账号',
            trigger: 'blur'
          },
        },
        emailRulse: {
          emailNo: {
            required: true,
            message: '请输入电子邮箱',
            trigger: 'blur'
          },
          EmailAddress: {
            required: true,
            message: '请输入电子邮箱',
            trigger: 'blur'
          },
          StartTime: {
            required: true,
            message: '请选择发送开始时间',
            trigger: 'blur'
          },
          endTime: {
            required: true,
            message: '请选择发送结束时间',
            trigger: 'blur'
          },
        },
        rules: {
          name: {
            required: true,
            message: '请输入',
            trigger: 'blur'
          },
          title: {
            required: true,
            message: '请输入文档标题',
            trigger: 'blur'
          },
          purpose: {
            required: true,
            message: '请选择用途',
            trigger: 'change'
          },
          sign: {
            required: true,
            message: '请选择标志',
            trigger: 'change'
          },
          url: {
            required: true,
            message: '请上传文件',
            trigger: 'change'
          },
        },
        aiSetform: {
          userid: Cookies.get("userid-b"),
          roletype: localStorage.loginRoletype,
          projectId: null,
          //我方结算单收发邮箱
          statementSenReceivedEmail: [],
          //客户发送结算单邮箱
          senReceivedEmail: [],
          mailSubjectKeyword: '', //邮件标题关键词
          inComeTpye: '', //算税方式
          IncomeTaxMonth: '',
          ExcelSheetNum: '',
          SpIncomeTaxType: '',
          SpAttrMonth: '',
          ExcelPwd: '',
          id: '',
          AttrMonth: '',
          PersonalTaxIsBorne:null,
          taxErrNotiy: '0', //算税失败通知项目客服 0否 1是
          isAutoPreTaxPayroll: false, //税前工资单自动
          isAutoPreTaxToCustomer: false, //税前工资单自动回传客户
          isAutoAfterTaxPayroll: false, //税后工资单自动
          isAutoAfterTaxToCustomer: false, //税后工资单自动回传客户
          isAutoStateAccount: false, //对账单自动
          isAutoStateAccountToCustomer: false, //对账单回传客户
        },
        showReceivedEmail: false,
        ReceivedForm: {
          EmailAddress: '',
          StartTime: '',
          endTime: '',
          pwd: '',
          Encryptpwd: ''
        },
        showSendEmail: false,
        sendForm: {
          EmailAddress: '',
          StartTime: '',
          endTime: '',
          pwd: '',
          Encryptpwd: ''
        },
        Encryptpwd: '', //加密密码
        showPwd: false,
        VerifCode: '', //验证码
        countdown: 0,
        isLift: false, //是否解除风控
        psw: '',
        proDocForm: {
          fileId: '',
          projectId: null,
          sign: null, //标志0：其他1：面试注意事项2：入职须知3：体检须知4：宿舍管理须知:5：离职流程6：安全相关须:7：员工手册
          purpose: null, //用途1：面试2：入职3：在职4：离职5：知识库
          title: '',
          remark: '',
          url: '',
          modifier: Cookies.get("userid-b"), //登录人
        },
        showAddProjectDoc: false,
        fileList: [],
        docData: [],
      }
    },
    created() {
      this.projectid = this.$route.query.projectid;
      this.getButtonPower();
      this.getlegalsubjectlist();
      this.getProAccountSetDetail();
      this.GetProjectEmailList();
      this.GetProjectInvoiceContentList();
      this.getlegalsubjectlist2();
      this.GetProjectDocumentationList();
    },
    methods: {
      checkPermission,
      // 获取按钮权限
      getButtonPower() {
        let that = this
        xz.getbtnPowerIdBypage(this.butQuery).then(res => {
          // console.log('按钮',res)
          if (res.status == 'ok') {
            let resmsg = res.msg
            if (!this.isNull(resmsg)) {
              for (let index = 0; index < resmsg.length; index++) {
                let element = resmsg[index];
                this.permissionLists.push(element.Enname);
              }
            } else {
              this.permissionLists = []
            }
          } else {
            this.permissionLists = []
          }
        })
      },
      changeTab() {
        if (this.activeName == '0') {
          this.$router.push({
            path: '/addProject',
            query: {
              isEdit: 'true',
              projectid: this.projectid
            }
          })
        }
      },
      //获取法务主体列表
      getlegalsubjectlist() {
        let data = {
          pageNum: '1',
          pageSize: '10000'
        }
        xz.getlegalsubjectlist(data).then(res => {
          if (res.status == 'ok') {
            this.legList = res.data.data;
          } else {
            this.legList = [];
          }
        })
      },
      //获取法务主体列表
      getlegalsubjectlist2() {
        let data = {
          keyWord: "",
          pageSize: "10000",
          UserId: Cookies.get("userid-b")
        };
        xz.BasicFun(data, "GetSubjectOfLegalAffairs").then((res) => {
          if (res.status == "ok") {
            this.legList2 = res.data;
          } else {
            this.legList2 = [];
          }
        });
      },
      //取套账详情
      getProAccountSetDetail() {
        if (this.projectid) {
          xz.getProAccountSetDetail(this.projectid).then(res => {
            if (res.status == 'ok') {
              this.bankData = res.data.CollectingBankList;
              this.invoiceData = res.data.InvoiceTitleList;
              this.legData = res.data.PayMasterList;
              this.payForm = res.data.ProAccountSet;
              if (res.data.ProAccountSet.Id != undefined) {
                this.aiSetform.id = res.data.ProAccountSet.Id;
              }
              try {
                if (res.data.ProAccountSet.StatementSenReceivedEmail != undefined) {
                  this.aiSetform.statementSenReceivedEmail = eval(res.data.ProAccountSet.StatementSenReceivedEmail)
                }
                if (res.data.ProAccountSet.SenReceivedEmail != undefined) {
                  this.aiSetform.senReceivedEmail = eval(res.data.ProAccountSet.SenReceivedEmail)
                }
                this.aiSetform.mailSubjectKeyword = res.data.ProAccountSet.MailSubjectKeyword;
                this.aiSetform.inComeTpye = res.data.ProAccountSet.InComeTpye;
                this.aiSetform.IncomeTaxMonth = res.data.ProAccountSet.IncomeTaxMonth;
                this.aiSetform.ExcelSheetNum = res.data.ProAccountSet.ExcelSheetNum;
                this.aiSetform.ExcelPwd = res.data.ProAccountSet.ExcelPwd;
                this.aiSetform.taxErrNotiy = res.data.ProAccountSet.TaxErrNotiy;
                this.aiSetform.isAutoPreTaxPayroll = res.data.ProAccountSet.IsAutoPreTaxPayroll;
                this.aiSetform.AttrMonth = res.data.ProAccountSet.AttrMonth;
                this.aiSetform.isAutoPreTaxToCustomer = res.data.ProAccountSet.IsAutoPreTaxToCustomer;
                this.aiSetform.isAutoAfterTaxPayroll = res.data.ProAccountSet.IsAutoAfterTaxPayroll;
                this.aiSetform.isAutoAfterTaxToCustomer = res.data.ProAccountSet.IsAutoAfterTaxToCustomer;
                this.aiSetform.isAutoStateAccount = res.data.ProAccountSet.IsAutoStateAccount;
                this.aiSetform.isAutoStateAccountToCustomer = res.data.ProAccountSet.IsAutoStateAccountToCustomer;
                this.aiSetform.SpIncomeTaxType = res.data.ProAccountSet.SpIncomeTaxType;
                this.aiSetform.SpAttrMonth = res.data.ProAccountSet.SpAttrMonth;
                this.aiSetform.PersonalTaxIsBorne = res.data.ProAccountSet.PersonalTaxIsBorne;
              } catch {}
            } else {
              this.bankData = [];
              this.invoiceData = [];
              this.legData = [];
            }
          })
        } else {
          this.$message.error('参数异常');
        }
      },
      //添加到款银行
      addRecBank() {
        this.bankForm = {
          Id: '',
          ProjectId: this.projectid,
          AccountName: '', //开户名
          Account: '', //帐号
          BankName: '', //银行名称
          OpeningBank: '', //开户行
          Remark: '', //	备注
          stateStr: '启用', //状态
        }
        this.showRecBank = true;
      },
      editBank(row) {
        this.bankForm = row;
        delete this.bankForm.UpdataTime;
        this.showRecBank = true;
      },
      confirmAddBank() {
        this.$refs["bankForm"].validate((valid) => {
          if (valid) {
            xz.updataCollectingBank(this.bankForm, this.roletype).then(res => {
              if (res.status == 'ok') {
                this.$message.success('保存成功');
                this.getProAccountSetDetail();
                this.showRecBank = false;
              } else {
                this.$message.error(res.msg);
                this.showRecBank = false;
              }
            })
          }
        })
      },
      delBnak(row) {
        xz.delCollectingBank(row.Id, this.roletype).then(res => {
          if (res.status == 'ok') {
            this.$message.success('作废成功');
            this.getProAccountSetDetail();
          } else {
            this.$message.error('作废失败');
          }
        })
      },
      //添加发票抬头
      addInvoice() {
        this.invoiceForm = {
          Id: '',
          ProjectId: this.projectid,
          AccountName: '', //抬头名称
          Account: '', //纳税人识别号
          PhoneNum: '', //电话号码
          OpeningBank: '', //开户行
          BankAccount: '', //银行账号
          BusinessAddress: '', //营业地址
          Remark: '', //	备注
          stateStr: '启用', //状态
        }
        this.showInvoice = true;
      },
      editInvoice(row) {
        this.invoiceForm = row;
        this.showInvoice = true;
      },
      confirmAddInvoice() {
        this.$refs['invoiceForm'].validate((valid) => {
          if (valid) {
            xz.updataInvoiceTitle(this.invoiceForm, this.roletype).then(res => {
              if (res.status == 'ok') {
                this.$message.success('保存成功');
                this.getProAccountSetDetail();
                this.showInvoice = false;
              } else {
                this.$message.error('保存失败');
                this.showInvoice = false;
              }
            })
          }
        })

      },
      delInvoice(row) {
        xz.delInvoiceTitle(row.Id, this.roletype).then(res => {
          if (res.status == 'ok') {
            this.$message.success('作废成功');
            this.getProAccountSetDetail();
          } else {
            this.$message.error('作废失败');
          }
        })
      },
      //添加主体
      addLeg() {
        this.legForm = {
          Id: '',
          ProjectId: this.projectid,
          AccountName: '', //主体名称
          BankAccount: '', //银行账号
          OpeningBank: '', //开户行
          BankName: '', //银行名称
          Remark: '', //	备注
          stateStr: '启用', //状态
        }
        this.showLeg = true;
      },
      editLeg(row) {
        this.legForm = row;
        this.showLeg = true;
      },
      confirmAddLeg() {
        xz.updataPayMaster(this.legForm, this.roletype).then(res => {
          if (res.status == 'ok') {
            this.$message.success('保存成功');
            this.getProAccountSetDetail();
            this.showLeg = false;
          } else {
            this.$message.error('保存失败');
            this.showLeg = false;
          }
        })
      },
      delLeg(row) {
        xz.delPayMaster(row.Id, this.roletype).then(res => {
          if (res.status == 'ok') {
            this.$message.success('作废成功');
            this.getProAccountSetDetail();
          } else {
            this.$message.error('作废失败');
          }
        })
      },
      //启用/停用
      stopHandle(row, type) {
        this.stopForm = {
          type: type, // 1到款银行 2 开票抬头 3发薪主体
          StateStr: row.StateStr == '启用' ? '停用' : '启用', //状态
          id: row.Id,
        }
        xz.updataCollectingBankstateStr(this.stopForm, this.roletype).then(res => {
          if (res.status == 'ok') {
            this.$message.success('保存成功');
            this.getProAccountSetDetail();
          } else {
            this.$message.error('保存失败');
          }
        })
      },
      //判断是否为空(包含0)
      isNull(o) {
        return o == undefined || o == "undefined" || (o + '').indexOf("undefined") > -1 || o == null || o == '' || o == 'null' || o == [] || o == 0
      },
      //修改薪酬相关
      saveAccountSet() {
        this.UpdataCompfinanceSet();
        this.payForm.ProjectId = this.projectid;
        delete this.payForm.CreateTime;
        console.log(this.payForm);
        xz.updataProAccountSet(this.payForm, this.roletype).then(res => {
          if (res.status == 'ok') {
            this.$message.success('保存成功');
            this.getProAccountSetDetail();
          } else {
            this.$message.error(res.msg);
          }
        })
      },
      UpdataCompfinanceSet() {
        if (this.aiSetform.mailSubjectKeyword) {
          this.aiSetform.mailSubjectKeyword = this.aiSetform.mailSubjectKeyword.replace(/，/g, ',')
        }
        this.aiSetform.projectId = this.projectid;
        xz.ArdCurStat(this.aiSetform, 'UpdataCompfinanceSet').then(res => {
          if (res.status == 'ok') {} else {
            this.$message.error(res.msg)
          }
        })
      },
      addEmail() {
        this.emailForm = {
          projectEmailId: '',
          projectId: this.projectid,
          emailNo: ''
        }
        this.showEmail = true;
      },
      delEmail() {},
      confirmAddEmail() {
        if (this.emailForm.emailNo) {
          this.isBtnLoading = true;
          xz.BasicFun(this.emailForm, 'PostProjectEmailSave').then(res => {
            if (res.status == 'ok') {
              this.$message.success('保存成功');
              this.isBtnLoading = false;
              this.GetProjectEmailList();
              this.showEmail = false;
            } else {
              this.$message.error(res.msg);
              this.isBtnLoading = false;
              this.GetProjectEmailList();
              this.showEmail = false;
            }
          })
        } else {
          this.$message.warning('请输入邮箱')
        }
      },
      GetProjectEmailList() {
        xz.GetProjectEmailList(this.projectid).then(res => {
          if (res.status == 'ok') {
            this.emailData = res.data;
          } else {
            this.emailData = []
          }
        })
      },
      addInvoicing() {
        this.invPresetsForm = {
          invoiceContentId: "",
          projectId: this.projectid,
          subjectOfLegalAffairsId: "", //主体id
          invoiceItem: '', //发票项目
          ticketTypeId: "", //票种id
          billingItemDetailsId: "", //开票内容id
          founder: Cookies.get("userid-b")
        }
        this.showInvoicing = true;
      },
      delInvoicing() {

      },
      confirmAddInvoicing() {
        this.showInvoicing = false;
        this.isBtnLoading = true;
        xz.BasicFun(this.invPresetsForm, 'PostProjectInvoiceContentSave').then(res => {
          if (res.status == 'ok') {
            this.GetProjectInvoiceContentList()
            this.$message.success('保存成功！');
            this.showInvoicing = false;
            this.isBtnLoading = false;
          } else {
            this.$message.error(res.msg);
            this.isBtnLoading = false;
          }
        })
      },
      GetProjectInvoiceContentList() {
        xz.GetProjectInvoiceContentList(this.projectid).then(res => {
          if (res.status == 'ok') {
            this.InvoicingData = res.data;
          } else {
            this.InvoicingData = [];
          }
        })
      },
      changeInvoiceItem() {
        this.invPresetsForm.billingItemDetailsId = '';
        this.invPresetsForm.ticketTypeId = '';
        this.GetTicketTypeForInvoice(this.invPresetsForm.subjectOfLegalAffairsId);
      },
      //获取票种
      GetTicketTypeForInvoice(id) {
        let iskc;
        if (this.invPresetsForm.invoiceItem > 0) {
          iskc = false
        } else {
          iskc = true;
        }
        xz.GetTicketTypeForInvoice(id, iskc).then(res => {
          if (res.status == 'ok') {
            this.ticketTypeList = res.data
          } else {
            this.ticketTypeList = [];
          }
        })
      },
      //选择票种
      changeTicketType(val) {
        this.invPresetsForm.billingItemDetailsId = '';
        let iskc;
        if (this.invPresetsForm.invoiceItem > 0) {
          iskc = false
        } else {
          iskc = true;
        }
        xz.GetBillingItemDetailsForInvoice(this.invPresetsForm.subjectOfLegalAffairsId, val, this.invPresetsForm.projectId, iskc).then(res => {
          if (res.status == 'ok') {
            this.BillingConList = res.data
          } else {
            this.BillingConList = [];
          }
        })
      },
      invStopHandle(row, status) {
        let d = {
          invoiceContentId: row.invoiceContentId,
          status,
          founder: Cookies.get("userid-b")
        }
        xz.BasicFun(d, 'PostProjectInvoiceContentDelete').then(res => {
          if (res.status == 'ok') {
            this.GetProjectInvoiceContentList();
            this.$message.success('操作成功');
          } else {
            this.$message.error(res.msg)
          }
        })
      },
      addReceivedEmail() {
        this.ReceivedForm = {
          EmailAddress: '',
          StartTime: '',
          endTime: '',
          pwd: '',
          Encryptpwd: ''
        }
        this.showReceivedEmail = true;
      },
      confirmReceivedEmail() {
        this.aiSetform.statementSenReceivedEmail.push(this.ReceivedForm);
        this.showReceivedEmail = false;
      },
      addSendEmail() {
        this.sendForm = {
          EmailAddress: '',
          StartTime: '',
          endTime: '',
          pwd: '',
          Encryptpwd: ''
        }
        this.showSendEmail = true;
      },
      confirmAddSendEmail() {
        this.$refs['sendForm'].validate((valid) => {
          if (valid) {
            this.aiSetform.senReceivedEmail.push(this.sendForm);
            this.showSendEmail = false;
          }
        })
      },
      delSendEmail(list, i) {
        this.aiSetform[list].splice(i, 1)
      },
      showPassword(row) {
        this.psw = '';
        this.Encryptpwd = row.Encryptpwd;
        this.showPwd = true;
      },
      sendSms() {
        this.isBtnLoading = true;
        let d = {
          ProjectId: this.projectid,
          Encryptpwd: this.Encryptpwd
        }
        xz.ArdCurStat(d, 'SendEmailPasswordVerifiCode').then(res => {
          if (res.status == 'ok') {
            this.isBtnLoading = false;
            this.$message.success('验证码发送成功');
            this.timecount();
          } else {
            this.isBtnLoading = false;
            this.$message.error(res.data);
          }
        })
      },
      timecount() {
        const TIME_COUNT = 60; //倒计时60秒
        if (!this.timer) {
          this.countdown = TIME_COUNT;
          this.isDisabled = true;
          this.timer = setInterval(() => {
            if (this.countdown > 0 && this.countdown <= TIME_COUNT) {
              this.countdown--;
            } else {
              clearInterval(this.timer);
              this.timer = null;
            }
          }, 1000);
        }
      },
      checkSms() {
        if (this.VerifCode) {
          let d = {
            Encryptpwd: this.Encryptpwd,
            VerifCode: this.VerifCode,
            ProjectId: this.projectid
          }
          xz.ArdCurStat(d, 'CheckEmailPasswordVerifiCode').then(res => {
            if (res.status == 'ok') {
              this.isLift = true;
              this.psw = res.data;
            } else {
              this.$message.error(res.msg)
            }
          })
        } else {
          this.$message.warning('请输入验证码')
        }
      },
      //复制
      repeatHandle() {
        navigator.clipboard.writeText(this.psw).then(() => {
          this.$message.success('复制密码成功')
        })
      },
      filterInput(value) {
        return value.replace(/[&\\]/g, '');
      },
      //新增项目文档
      AddProjectDoc() {
        this.isBtnLoading = false;
        this.proDocForm = this.$options.data.call(this).proDocForm;
        this.proDocForm.projectId = this.projectid;
        this.fileList = [];
        this.showAddProjectDoc = true;
      },
      handleUpload(file) {
        const formData = new FormData();
        formData.append("pagename", "docinf");
        formData.append("action", "save");
        formData.append("userid", Cookies.get("userid-b"));
        formData.append("entid", Cookies.get("userid-b"));
        formData.append("excel", file.raw, file.name);
        console.log("formData", formData);
        xz.uploadCert(formData).then((res) => {
          if (res) {
            this.proDocForm.url = res;
          } else {
            this.proDocForm.url = ''
          }
        });
      },
      handleRemove() {
        this.proDocForm.url = '';
        this.fileList = [];
      },
      handleExceed() {
        this.$message.warning(`最多上传 1 个文件，请先删除再上传`);
      },
      confirmAddDoc() {
        this.$refs['proDocForm'].validate((valid) => {
          if (valid) {
            this.isBtnLoading = true;
            xz.BasicFun(this.proDocForm, 'SetProjectDocumentationSave').then(res => {
              if (res.status == 'ok') {
                this.$message.success('保存成功');
                this.isBtnLoading = false;
                this.GetProjectDocumentationList();
                this.showAddProjectDoc = false;
              } else {
                this.$message.error(res.msg);
                this.isBtnLoading = false;
                this.GetProjectDocumentationList();
                this.showAddProjectDoc = false;
              }
            })
          }
        })
      },
      GetProjectDocumentationList() {
        let str = `GetProjectDocumentationList?ProjectId=${this.projectid}`
        xz.BasicGetFun(str).then(res => {
          if (res.status == 'ok') {
            this.docData = res.data;
          } else {
            this.docData = [];
          }
        })
      },
      downFile(row) {
        var path = this.$store.state.EMP.docPath + row.url;
        const aTag = document.createElement('a')
        aTag.href = path;
        aTag.setAttribute('download', row.title);
        aTag.click();
      },
      //停用/启用/删除
      stopDoc(row, Status) {
        let str = `SetProjectDocumentationDelete?FileId=${row.fileId}&Status=${Status}&Modifier=${Cookies.get("userid-b")}`
        xz.BasicGetFun(str, 'DELETE').then(res => {
          if (res.status == 'ok') {
            this.$message.success('保存成功');
          } else {
            this.$message.error(res.msg);
          }
          this.GetProjectDocumentationList();
        })
      },
      changePreTax(val) {
        if (!val) {
          this.aiSetform.isAutoPreTaxToCustomer = false;
        }
      },
      changeAfterTax(val) {
        if (!val) {
          this.aiSetform.isAutoAfterTaxPayroll = false;
        }
      },
      changeStateAccount(val) {
        if (!val) {
          this.aiSetform.isAutoStateAccountToCustomer = false;
        }
      },
    }
  }
</script>

<style lang="scss" scoped>
  .ftabs {
    background: #fff;
    padding: 0px 16px 16px;
    margin-bottom: 16px;
  }

  .setTitle {
    font-weight: 600;
    font-size: 14px;
    margin-bottom: 15px;
  }

  .setItem {
    margin-bottom: 20px;
  }

  .tips {
    color: red;
    margin-bottom: 10px;
    padding-left: 30px;
  }

  .r_icon01 {
    color: #777474;
    font-size: 18px;
    margin-left: 10px;
  }
</style>
<style>
  .page_acSet .eleTabBtn .el-button--text {
    color: #19bd92;
    font-size: 13px;
    padding: 0;
  }

  .page_acSet .doc_table .el-table__body td.el-table__cell {
    padding: 5px 0;
  }

  .page_acSet .doc_table .el-table__body th.el-table__cell {
    padding: 8px 0;
  }

  .page_acSet .el-input__icon {
    height: 32px;
    line-height: 32px;
  }

  .page_acSet .el-input-group__append,
  .el-input-group__prepend {
    padding: 0 10px;
    background: #fff;
  }

  .page_acSet .el-button--text {
    color: #19bd92;
    font-size: 13px;
    padding: 0;
  }

  .page_acSet .setTitle .el-button--text {
    color: #409eff;
    font-size: 13px;
    padding: 0;
    margin-left: 10px;
  }

  .page_acSet .settlement_form .el-form-item {
    margin-bottom: 5px;
  }
</style>